export default __webpack_public_path__ + "static/media/react.c3a0b34a.svg";